import React, { useEffect, useState } from 'react';
import { mdiChartTimelineVariant, mdiCartOutline } from '@mdi/js';
import { useHistory, useLocation } from 'react-router-dom';
import { Menu } from 'antd';
import { useWidgetDate } from 'store/redux/states/dates/dates.hooks';
import Icon from '@mdi/react';
import P from 'router/paths';
import { mdiHandshake } from '@mdi/js';

const items = [
  {
    label: 'Charts',
    url: P.ACQUISITION.INDEX,
    key: 'charts',
    icon: <Icon path={mdiChartTimelineVariant} />,
  },
  {
    key: 'deals',
    icon: <Icon path={mdiHandshake} />,
    label: 'Deals',
    url: P.ACQUISITION.DEALS,
  },
];

const AcquisitionMainMenu = ({ dateRangeComponent }) => {
  const { queryParams } = useWidgetDate('global');

  const [selected, setSelected] = useState();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const key = items.find((item) => item.url === location.pathname)?.key;
    setSelected(key);
  }, [location.pathname]);

  const onSelect = ({ key }) => {
    const selectedItem = items.find((item) => item.key === key);
    if (selectedItem) {
      history.push(selectedItem.url + queryParams);
      setSelected(key);
    }
  };

  return (
    <div className='flex flex-col items-center justify-between gap-2 px-4 pt-1 pr-8 sm:flex-row'>
      <Menu
        className='w-full order-1 sm:order-0 !border-none'
        mode='horizontal'
        selectedKeys={[selected]}
        onSelect={onSelect}
        items={items}
      />
      <div className='w-full sm:max-w-44 order-0 sm:order-1'>{dateRangeComponent}</div>
    </div>
  );
};

export default AcquisitionMainMenu;
